export const userPage = {
    userPageAddPet: {
        rbmail: {
            type: 'click',
            id: '59502135',
        },
    },
    userPageAskQuestion: {
        rbmail: {
            type: 'click',
            id: '60110479',
        },
    },
    userPageAskConsultant: {
        rbmail: {
            type: 'click',
            id: '60110477',
        },
    },
    userPageAppointmentDesktop: {
        rbmail: {
            id: '154365432',
        },
    },
    userPageAppointmentTouch: {
        rbmail: {
            id: '154365433',
        },
    },
};
